export default {
    TABLE_TITLE: 'Modules',
    MODULE_ADDED: 'Module added',
    MODULE_EDITED: 'Module edited',
    MODULE_DELETED: 'Module deleted',
};
